
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertCategoryB as ObiAlertCategoryBElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-category-b.js';
 
 
 

 
 export const ObiAlertCategoryB = createComponent({
   react: React,
   tagName: 'obi-alert-category-b',
   elementClass: ObiAlertCategoryBElement,
   events: {
     
   }
  });
 
 